
import "./PolicyPages.css";

const Terms = () => {
  return (
    <div className="policy-page">
      <div className="policy-header">
        <h1>Terms and Conditions</h1>
        
      </div>

      <div className="policy-content">
        <section className="policy-section">
          <h2>Acceptance of Terms</h2>
          <p>
            By accessing and using the services of Vero Disruptors Private Limited ("Company," "we," "us," 
            or "our"), you agree to be bound by these Terms and Conditions. If you disagree with any part 
            of these terms, you may not access our services.
          </p>
        </section>

        <section className="policy-section">
          <h2>Services Description</h2>
          <p>
            Vero Disruptors provides IT and software services including but not limited to:
          </p>
          <ul>
            <li>Data Science and AI Solutions</li>
            <li>Software Development and Consulting</li>
            <li>Talent Development and Recruitment Services</li>
            <li>Mobile and Web Application Development</li>
            <li>Automation Solutions using Data</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>Intellectual Property Rights</h2>
          <p>
            All content, features, and functionality available through our services, including but not 
            limited to text, graphics, logos, icons, images, audio clips, and software, are the exclusive 
            property of Vero Disruptors or its licensors and are protected by copyright, trademark, and 
            other intellectual property laws.
          </p>
        </section>

        <section className="policy-section">
          <h2>User Responsibilities</h2>
          <p>As a user of our services, you agree to:</p>
          <ul>
            <li>Provide accurate and complete information</li>
            <li>Maintain the confidentiality of your account credentials</li>
            <li>Use the services only for lawful purposes</li>
            <li>Not attempt to gain unauthorized access to any part of our services</li>
            <li>Not interfere with or disrupt the services or servers</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>Payment Terms</h2>
          <p>
            Payment for services will be specified in individual service agreements. Unless otherwise 
            stated, all payments are due upon receipt of invoice. Late payments may be subject to interest 
            charges at the rate of 1.5% per month.
          </p>
        </section>

        <section className="policy-section">
          <h2>Service Modifications</h2>
          <p>
            We reserve the right to modify or discontinue, temporarily or permanently, any part of our 
            services with or without notice. We shall not be liable to you or any third party for any 
            modification, price change, suspension, or discontinuance of the service.
          </p>
        </section>

        <section className="policy-section">
          <h2>Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by applicable law, Vero Disruptors shall not be liable for 
            any indirect, incidental, special, consequential, or punitive damages, including without 
            limitation, loss of profits, data, use, goodwill, or other intangible losses.
          </p>
        </section>

        <section className="policy-section">
          <h2>Indemnification</h2>
          <p>
            You agree to defend, indemnify, and hold harmless Vero Disruptors and its licensees and 
            licensors from and against any claims, damages, obligations, losses, liabilities, costs, 
            or debt arising from your use of our services.
          </p>
        </section>

        <section className="policy-section">
          <h2>Governing Law</h2>
          <p>
            These Terms shall be governed and construed in accordance with the laws of India, without 
            regard to its conflict of law provisions. Any disputes arising under these terms shall be 
            subject to the exclusive jurisdiction of the courts in Prakasam, Andhra Pradesh.
          </p>
        </section>

        <section className="policy-section">
          <h2>Changes to Terms</h2>
            <p>
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. 
              We will provide at least 30 days' notice prior to any new terms taking effect.
            </p>
          </section>

        <section className="policy-section contact-section">
          <h2>Contact Information</h2>
          <div className="contact-info">
            <p><strong>Email:</strong> venkatmor@verodisruptors.com</p>
            <p><strong>Phone:</strong> +91 9032584791</p>
            <p>
              <strong>Address:</strong> H.No: 3-77, Thimmanapalem(V),
Korisapadu (MD), Bapatla (DT),
Andhra Pradesh, India - 523212
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Terms;